export type VoucherFormValues = {
  productName: string
  discountType: string
  discountValue: number | ''
  code: string
  brandId: string
  expiresAt: string
  usageLimit: number | ''
  mechanism: string
  offerAttributes: {
    partnerName: string
    offer: string
  }
}

export const getDefaultVoucherExpiryDate = (): string => {
  const now = new Date()
  const nextMonthDate = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1, 0, 0, 0, 0)
  )
  const year = nextMonthDate.getUTCFullYear()
  const month = String(nextMonthDate.getUTCMonth() + 1).padStart(2, '0')

  return `${year}-${month}-01T00:00:00.000Z`
}

export const INITIAL_VOUCHER_VALUES: VoucherFormValues = {
  productName: '',
  discountType: '',
  discountValue: '',
  code: '',
  brandId: '',
  expiresAt: getDefaultVoucherExpiryDate(),
  usageLimit: '',
  mechanism: '',
  offerAttributes: {
    partnerName: '',
    offer: '',
  },
}
